/**
 * Landing Page
 * Main entry point for Project NAVIGATOR
 */

export async function renderLandingPage(appElement: HTMLDivElement): Promise<void> {
  appElement.innerHTML = `
    <div class="landing-container">
      <header class="landing-header">
        <h1>Project NAVIGATOR</h1>
      </header>

      <main class="landing-main">
        <nav class="landing-nav">
          <a href="/qud-map" class="nav-card">
            <h2>Caves of Qud Map</h2>
            <p>Interactive world map with population heatmaps</p>
          </a>
          <a href="/sprite-demo" class="nav-card">
            <h2>Sprite Demo</h2>
            <p>Custom Aseprite sprites with dynamic colorization</p>
          </a>
          <a href="/audio-demo" class="nav-card">
            <h2>Audio Demo</h2>
            <p>SNES-style synthesizer with 8 voices, ADSR, and echo</p>
          </a>
          <a href="/sample-browser" class="nav-card">
            <h2>Sample Browser</h2>
            <p>Browse and play BRR samples from 1500+ SNES games</p>
          </a>
          <a href="/sequence-test" class="nav-card">
            <h2>Sequence Test</h2>
            <p>YAML-based composition engine for SNES audio</p>
          </a>
        </nav>
      </main>

      <footer class="landing-footer">
        <span>Project NAVIGATOR</span>
      </footer>
    </div>
  `;
}
